import React, { FC } from 'react'

import { IconFamilyProps } from './IconFamily.types'
import * as Styled from './styles/IconFamily.style'

import { nonThemeableRules } from '../../ruleSet'

const IconFamily: FC<IconFamilyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconFamilyProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconFamilyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M151.94 108.59c-2.75-15.93-10.77-27.82-21.72-33.28a24 24 0 1 0-28.44 0q-.68.34-1.35.71a20.89 20.89 0 0 0-25.64.57q-1.18-.61-2.4-1.14a32 32 0 1 0-32.78 0c-15.93 7-27.69 24.25-31.56 47.88a4 4 0 1 0 7.89 1.29C20.39 97.56 36.11 80.06 56 80.06h.1a32.73 32.73 0 0 1 13.41 2.89 21 21 0 0 0 5.39 26.39c-9.24 5.16-16 15.82-18.5 30a4 4 0 1 0 7.88 1.36c2.79-16.12 11.56-26.28 23-26.78h1.55c11.34.38 20.07 10.57 22.88 26.78a4 4 0 0 0 7.88-1.36c-2.5-14.44-9.15-25-18.34-30.11a20.91 20.91 0 0 0 4.76-27 23.67 23.67 0 0 1 9.91-2.23h.08c14.12 0 24.87 11.48 28.06 29.95a4 4 0 0 0 7.88-1.36zM32 48a24 24 0 1 1 24 24 24 24 0 0 1-24-24zm56.17 57.88h-.9a13 13 0 1 1 1.58 0zM116 40a16 16 0 1 1-16 16 16 16 0 0 1 16-16z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconFamily
